import { LOAD_FAILED_MARKER } from "#ce/framework/mount-ready";

export const FINDER_NOT_FOUND = "finder-not-found";
export const FINDER_MULTIPLE = "finder-multiple";
export const FINDER_LOAD_FAILED = "finder-load-failed";
const FINDER_LINK_NOT_SUPPORTED = "finder-link-not-supported";
export const REQUIRED_FILTERS_OPEN_EVENT = "required-filters-open";

/** Finds the nearest enclosing finder across shadow hosts; multiple finders are ambiguous only for an outside block. */
export function resolveFinder(host, finder) {
  if (finder != null) {
    return {
      error: FINDER_LINK_NOT_SUPPORTED,
    };
  }

  if (!host?.isConnected) {
    return {
      error: FINDER_NOT_FOUND,
    };
  }

  let element = host;

  while (element && element.localName !== "sp-finder") {
    element = element.parentElement ?? element.getRootNode()?.host;
  }

  if (!element) {
    const wrappers = [];
    let root = host.getRootNode();

    while (root) {
      wrappers.push(...root.querySelectorAll("sp-finder"));
      root = root.host?.getRootNode();
    }

    if (wrappers.length > 1) {
      return {
        error: FINDER_MULTIPLE,
        count: wrappers.length,
      };
    }

    return {
      error: FINDER_NOT_FOUND,
    };
  }

  if (element.hasAttribute(LOAD_FAILED_MARKER)) {
    return {
      error: FINDER_LOAD_FAILED,
    };
  }

  return {
    element,
  };
}
